// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2UVDO","colBig":"styles_colBig__1oc4C","colSmall":"styles_colSmall__2zQgM"};